<button
  class="button-wrapper"
  [class.disabled]="disabled"
  [class.module-disabled]="!moduleEnabled"
  [attr.data-analytics]="id"
  [attr.data-test]="id"
  (click)="navigate()">
  <mg-card
    [ngClass]="metricData.color"
    paddingX="2-half"
    paddingY="2-half">
    <div
      fxLayout="column"
      fxLayoutAlign="space-between start"
      fxLayoutGap="6px">
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="4px">
        <mg-icon
          class="metric-icon"
          [ngClass]="metricData.color"
          [iconName]="metricData.iconName">
        </mg-icon>
        <mg-text
          variant="label-md"
          [numberOfLines]="2"
          [color]="moduleEnabled ? 'surface' : 'surface-alt'">
          {{ metricData.labelName }}
        </mg-text>
      </div>
      <div
        *ngIf="moduleEnabled"
        class="tw-w-full tw-flex tw-justify-between tw-items-center">
        <mg-text variant="header-xl-secondary">
          {{ value | number }}
        </mg-text>
        <mg-icon
          *ngIf="!disabled"
          class="chevron-icon"
          iconName="mg-chevron-right">
        </mg-icon>
      </div>
      <mg-btn
        *ngIf="!moduleEnabled"
        variant="text"
        size="small"
        (pressed)="openSubscriptionModal(metricData.moduleConfig)">
        {{ MESSAGES.LEARN_MORE_LABEL }}
      </mg-btn>
    </div>
  </mg-card>
</button>
